import {
  AccountType,
  WecomFriendApplyData,
  WecomInnerContact,
  WecomOuterContact,
  WecomRoom,
} from "@packages/chat-sdk";
import { Store } from "./store";
export interface WecomContactsStoreType {
  selectedContactOrRoom?:
    | WecomOuterContact
    | WecomInnerContact
    | WecomRoom
    | WecomFriendApplyData;
  // 群聊二维码，
  roomQRCodesMap: Record<string, string>;
}

export const wecomContactsStore = new Store<WecomContactsStoreType>(() => ({
  selectedContactOrRoom: undefined,
  roomQRCodesMap: {},
}));
export const wecomContactsStoreActions = {
  setSelectedContactOrRoom(
    payload?:
      | WecomOuterContact
      | WecomInnerContact
      | WecomRoom
      | WecomFriendApplyData
  ) {
    wecomContactsStore.set({
      selectedContactOrRoom: payload,
    });
  },
  refreshRoomQRCodesMap(payload: Record<string, string>) {
    wecomContactsStore.set({
      roomQRCodesMap: payload,
    });
  },
};
